export var AddressType;
(function (AddressType) {
    AddressType[AddressType["MAIN_OFFICE"] = 1] = "MAIN_OFFICE";
    AddressType[AddressType["SHIPPING"] = 2] = "SHIPPING";
    AddressType[AddressType["BILLING"] = 3] = "BILLING";
    AddressType[AddressType["REMIT_TO"] = 4] = "REMIT_TO";
})(AddressType || (AddressType = {}));
//# sourceMappingURL=address-type.js.map